import React, { Component } from 'react';
import { Button } from '../antd';
import { clientClient, gsClient, providerClient } from 'servicesCommon/client';
import queryString from 'query-string';
import { AxiosResponse } from 'axios';
import { TypeOfInvoices } from 'app-types';

interface Props {
	invoiceBookingId: number;
	invoiceBookingNumber: string;
	showName: boolean;
	type: TypeOfInvoices;
}
export class DownloadButton extends Component<Props> {
	static defaultProps = {
		showName: false,
	};
	getClient = () => {
		switch (process.env.REACT_APP_NAME) {
			case 'gs':
				return {
					client: gsClient,
					path: this.getGSPdfUrl(),
				};
			case 'clients':
				return {
					client: clientClient,
					path: this.getClientUrl(),
				};
			case 'providers':
				return {
					client: providerClient,
					path: this.getSpUrl(),
				};
			default:
				return null;
		}
	};

	getGSPdfUrl = () => {
		switch (this.props.type) {
			case 'GS':
				return 'invoices-generated/get-groundscope-pdf-invoice';
			case 'SP':
				return 'invoices-generated/get-service-partner-pdf-invoice';
			case 'TR':
				return 'invoices-generated/get-travel-summary-pdf';
			case 'ST':
				return 'service-partner-statements/get-service-partner-statement-pdf';
			case 'GSD':
				return 'invoices-declined/get-groundscope-pdf-invoice';
			case 'SPD':
				return 'invoices-declined/get-service-partner-pdf-invoice';
			case 'TRD':
				return 'invoices-declined/get-travel-summary-pdf';
			default:
				return null;
		}
	};

	getClientUrl() {
		return '/bookings/get-travel-summary-pdf';
	}

	getSpUrl() {
		switch (this.props.type) {
			case 'SP':
				return 'invoices/get-service-partner-pdf-invoice';
			case 'ST':
				return 'invoices/get-service-partner-statement-pdf';
			default:
				return null;
		}
	}

	getFileName() {
		const { type, invoiceBookingNumber } = this.props;
		if (type === 'ST') {
			return `${invoiceBookingNumber}.pdf`;
		} else {
			return `${type!.charAt(0)}${invoiceBookingNumber}.pdf`;
		}
	}

	handlePdf = (response: AxiosResponse<Blob>) => {
		const blob = new Blob([response.data]);
		const filename = this.getFileName();
		if (window.navigator && window.navigator.msSaveOrOpenBlob) {
			// IE fix
			window.navigator.msSaveOrOpenBlob(blob, filename);
		} else {
			const url = URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.style.display = 'none';
			link.href = url;
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			if (link.parentNode) {
				// IE fix
				link.parentNode.removeChild(link);
			}
			URL.revokeObjectURL(url);
		}
	};

	getParams = () => {
		const { invoiceBookingId } = this.props;
		const paramKey = this.props.type === 'ST' ? 'statementId' : 'invoiceBookingId';
		return {
			[paramKey]: invoiceBookingId,
		};
	};

	retrievePdfInvoiceFunc = () => {
		const { client = null, path = null } = this.getClient() || {};
		const params = this.getParams();
		if (client && path) {
			client
				.get<Blob>(path, {
					params,
					responseType: 'blob',
					paramsSerializer: (requestParams: any) =>
						queryString.stringify(requestParams, {
							arrayFormat: 'none',
						}),
				})
				.then(this.handlePdf)
				.catch(error => {
					console.error('error', error);
				});
		}
	};
	render() {
		const { showName, invoiceBookingNumber } = this.props;
		const name = showName ? invoiceBookingNumber : '';
		return (
			<Button size="small" icon="download" onClick={this.retrievePdfInvoiceFunc}>
				{name}
			</Button>
		);
	}
}
